import { Component, input } from '@angular/core';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { LetsikringRevision } from '@features/letregister/letsikring-revision.model';
import { LetsikringRisiko } from '@features/letregister/letsikring-risiko.model';
import { Letsikring } from '@features/letregister/letsikring.model';

@Component({
  selector: 'app-letsikring-system',
  imports: [BooleanPipe],
  templateUrl: './letsikring-system.component.html',
  styleUrl: './letsikring-system.component.css',
})
export class LetsikringSystemComponent {
  revision = input.required<LetsikringRevision>();
  letsikring = input.required<Letsikring>();
  risiko = input.required<LetsikringRisiko | undefined>();
}
